import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    question: 'How does Hermo access my emails?',
    answer: 'Hermo connects to your email provider through secure OAuth protocols, similar to how other trusted email apps connect. We never store your email password, and you can revoke access at any time.'
  }, {
    question: 'Is my email data secure with Hermo?',
    answer: 'Absolutely. We use industry-standard encryption and security practices. We never share your data with third parties and your data is never used to train external 3rd party AI models like OpenAI.'
  }, {
    question: 'Which email providers does Hermo work with?',
    answer: "Hermo currently works with Gmail. We're actively working on adding support for more email providers."
  }, {
    question: 'Can I customize how Hermo prioritizes my emails?',
    answer: 'Yes! Hermo is highly customizable. You can define exactly what types of emails are important to you, how they should be tagged, and how you want to be notified.'
  }, {
    question: 'How do I set up reminders with Hermo?',
    answer: "Simply tell Hermo what you want to be reminded about in natural language. For example, 'Remind me about insurance renewals' or 'Alert me about school trip deadlines.'"
  }, {
    question: 'Is there a free trial available?',
    answer: 'Yes, we offer a 7-day free trial with full access to all features.'
  }, {
    question: "Will you delete my data if I don't like Hermo?",
    answer: 'Yes, we will delete all user data within 48 hours.'
  }, {
    question: 'How much does Hermo cost?',
    answer: 'Hermo starts at £10 + Sales Tax per user per month.'
  }];
  return <section id="faq" className="py-32 px-6 md:px-12 lg:px-24 bg-[#fffefc]" data-id="element-11">
      <div className="max-w-3xl mx-auto" data-id="element-12">
        <div className="text-center mb-16" data-id="element-13">
          <h2 className="text-3xl md:text-4xl font-display font-bold text-[#2D1810] mb-4" data-id="element-14">
            Frequently Asked Questions
          </h2>
          <p className="text-xl text-[#6B5244]" data-id="element-15">
            Everything you need to know about Hermo
          </p>
        </div>
        <div className="space-y-6" data-id="element-16">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} data-id="element-17" />)}
        </div>
      </div>
    </section>;
}
function FAQItem({
  question,
  answer
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border border-[#E8DFD8] rounded-lg overflow-hidden" data-id="element-18">
      <button className="w-full px-6 py-4 text-left bg-[#fffefc] hover:bg-[#F5F0ED] flex justify-between items-center transition-colors" onClick={() => setIsOpen(!isOpen)} data-id="element-19">
        <span className="font-semibold text-[#2D1810]" data-id="element-20">{question}</span>
        {isOpen ? <ChevronUp size={20} className="text-[#6B5244]" data-id="element-21" /> : <ChevronDown size={20} className="text-[#6B5244]" data-id="element-22" />}
      </button>
      {isOpen && <div className="px-6 py-4 bg-[#fffefc] border-t border-[#E8DFD8]" data-id="element-23">
          <p className="text-[#6B5244]" data-id="element-24">{answer}</p>
        </div>}
    </div>;
}